import React from 'react';
import { useLocalization } from '../../../../context/Localization/localization';
import OptionBoxes from '../../../../controls/OptionBoxes/OptionBoxes';
import css from './LockerOpenIssue.module.scss';
import { useTowInProcess } from '../../../../context/Appointment/appointment';
import SingleOptionBox from '../../../../controls/OptionBoxes/SingleOptionBox';

interface IProps {
    onTryAgain: () => void;
    onSeeAdvisor: () => void;
}

export const LockerOpenIssue: React.FC<IProps> = (props: IProps) => {
    const Localization = useLocalization();
    const towInProcess = useTowInProcess();

    return (
        towInProcess ? (
            <SingleOptionBox
                primaryText={
                    <div className={css.tipsList}>
                        <div className={css.listHeader}>{Localization.LockerScanningTips}</div>
                        <ol>
                            <li>{Localization.LockerScanningTips1}</li>
                            <li>{Localization.LockerScanningTips2}</li>
                            <li>{Localization.LockerScanningTips3}</li>
                            <li>{Localization.LockerScanningTips4}</li>
                        </ol>
                    </div>
                }
                primaryButtonText={Localization.TryAgain}
                onPrimaryClick={props.onTryAgain}
            />
        ) : (
            <OptionBoxes
                primaryText={
                    <div className={css.tipsList}>
                        <div className={css.listHeader}>{Localization.LockerScanningTips}</div>
                        <ol>
                            <li>{Localization.LockerScanningTips1}</li>
                            <li>{Localization.LockerScanningTips2}</li>
                            <li>{Localization.LockerScanningTips3}</li>
                            <li>{Localization.LockerScanningTips4}</li>
                        </ol>
                    </div>
                }
                primaryButtonText={Localization.TryAgain}
                secondaryText={Localization.CheckInWithAdvisor}
                secondaryButtonText={Localization.SeeAdvisor}
                onPrimaryClick={props.onTryAgain}
                onSecondaryClick={props.onSeeAdvisor}
            />
        )
    );
};
